import vueSubscriptionSvc from '../../services/vueSubscriptionSvc';
import { shipRefillWithCart } from "../../services/vueCartSvc";

const path = './Dashboard/Purchases/EditAutoDelivery';

const state = {
  savingSub: false,
  subs: [],
  subInEdit: {},
  cancelReasons: [],
  cancelData: {
    reason: {},
    comment: null
  },
  subsToUpdate: [],
  defaultFrequencies: '2, 3, 4, 5, 6, 7, 8'
};

export const getters = {
  subscriptionIds(state) {
    return state.subs.map(sub => sub.id);
  },

  activeSubscriptionIds(state) {
    return state.subs.filter(sub => !sub.inactive).map(sub => sub.id);
  },

  activeSubscriptions(state) {
    return state.subs.filter(sub => !sub.inactive);
  },

  inactiveSubs(state) {
    return state.subs.filter(sub => sub.inactive);
  },

  subsGroupedByNext(state) {
    var subsGroupedByNext = [];

    var subObj = state.subs.reduce((rv, sub) => {
      if (!sub.inactive) {
        (rv[sub.next] = rv[sub.next] || []).push(sub);
      }
      return rv;
    }, {});

    Object.keys(subObj).forEach(key => {
      subsGroupedByNext.push(subObj[key]);
    });

    return subsGroupedByNext;
  },

  subsGroupedByNextWithOnTheWay(state, getters, rootState, rootGetters) {
    var subsGroupedByNextWithOnTheWay = [];

    var subObj = state.subs.reduce((rv, sub) => {
      if (!sub.inactive) {
        var onTheWayKey = rootGetters['customer/onTheWaySubsMap'][sub.id] ? 'onTheWay' : '';
        (rv[onTheWayKey + sub.next] = rv[onTheWayKey + sub.next] || []).push(sub);
      }
      return rv;
    }, {});

    Object.keys(subObj).forEach(key => {
      if (key.includes('onTheWay')) {
        subsGroupedByNextWithOnTheWay.push(subObj[key]);
      }
    });

    Object.keys(subObj).forEach(key => {
      if (!key.includes('onTheWay')) {
        subsGroupedByNextWithOnTheWay.push(subObj[key]);
      }
    });

    return subsGroupedByNextWithOnTheWay;
  },

  nextSubShipment(state, getters) {
    let next = [];

    if (getters.subsGroupedByNext && getters.subsGroupedByNext.length) {
      next = getters.subsGroupedByNext[0];
    } else if (getters.inactiveSubs.length) {
      //- if user does not have any active subs with next date pull one from inactive
      //- and we will suggest them to reactivate it
      next = [getters.inactiveSubs[0]];
    }

    return next;
  },

  getSubById: (state) => (id) => {
    return state.subs.find(sub => sub.id == id) || {};
  }
};

export const actions = {
  //- use this when need to ensure that subs are loaded
  initSubscriptions({ state, dispatch }) {
    if (state.subs.length) {
      return;
    }
    dispatch('loadCustomerSubs');
  },

  //- subs refresh/load
  loadCustomerSubs({ commit, dispatch }) {
    vueSubscriptionSvc.getSubscriptions().then(res => {
      let sortedSubs = (res.data.subs || []).sort((a, b) => {
        return (+new Date(a.next)) - (+new Date(b.next));
      });

      commit('setSubs', sortedSubs);
    }).catch(() => {
      dispatch('notifyError', null, { root: true });
    });
  },

  populateSubInEditById({ commit, getters }, params) {
    if (params && params.subId) {
      commit('setSubInEdit', getters.getSubById(params.subId));
    }
  },

  openPostponeModal({ dispatch }, params) {
    dispatch('populateSubInEditById', params);
    dispatch('modal/showModal', { component: './Dashboard/Purchases/PostponeSubscriptionModal' }, { root: true });
  },

  editAutoDeliveryAddressModal({ dispatch }, params) {
    dispatch('populateSubInEditById', params);
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryAddressModal` }, { root: true });
  },

  editAutoDeliveryPaymentModal({ dispatch }, params) {
    dispatch('populateSubInEditById', params);
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryPaymentModal` }, { root: true });
  },

  editAutoDeliveryFrequencyModal({ dispatch }, params) {
    dispatch('populateSubInEditById', params);
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryFrequencyModal` }, { root: true });
  },

  editAutoDeliveryChangeColorModal({ dispatch }, params) {
    dispatch('populateSubInEditById', params);
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryChangeColorModal`, theme: params.theme }, { root: true });
  },

  editAutoDeliveryCancelModal({ dispatch }, params) {
    dispatch('populateSubInEditById', params);
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryCancelModal` }, { root: true });
  },

  editAutoDeliveryCancelReasonsModal({ dispatch }, params) {
    dispatch('populateSubInEditById', params);
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryCancelReasonsModal` }, { root: true });
  },

  editAutoDeliveryCancelOfferModal({ dispatch }) {
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryCancelOfferModal` }, { root: true });
  },

  editAutoDeliveryCancelFinalModal({ dispatch }) {
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryCancelFinalModal` }, { root: true });
  },

  editAutoDeliveryPauseModal({ dispatch }) {
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryPauseModal` }, { root: true });
  },

  editAutoDeliveryChooseDateModal({ dispatch }) {
    dispatch('modal/showModal', { component: `${path}/EditAutoDeliveryChooseDateModal` }, { root: true });
  },

  updateSubscription({ commit, dispatch, state }, params) {
    if (state.savingSub) {
      return;
    }

    commit('setSavingSub', true);
    return new Promise((resolve, reject) => {
      vueSubscriptionSvc.updateSubscription(params)
        .then(() => {
          dispatch('loadCustomerSubs');
          dispatch('customer/refreshCustomerCdata', null, { root: true });
          resolve();
          dispatch('notifySuccess', 'You have successfully updated your subscription.', { root: true });
          commit('setSavingSub', false);
        })
        .catch(() => {
          commit('setSavingSub', false);
          dispatch('notifyError', null, { root: true });
          reject();
        });
    });
  },

  updateSubscriptionColor({ commit, dispatch, state }, params) {
    if (state.savingSub) {
      return;
    }

    commit('setSavingSub', true);
    return new Promise((resolve, reject) => {
      vueSubscriptionSvc.updateSubscriptionColor(params).then(() => {
        dispatch('loadCustomerSubs');
        resolve();
        dispatch('notifySuccess', 'You have successfully updated your subscription.', { root: true });
        commit('setSavingSub', false);
      }).catch(() => {
        commit('setSavingSub', false);
        dispatch('notifyError', null, { root: true });
        reject();
      });
    });
  },

  addSubAttachment({ dispatch, getters }, params) {
    let { sub_id, product_id, qty, ctaSource } = params;
    let sub = getters.getSubById(sub_id);

    let payload = {
      sub_id,
      changes: {
        products: [...sub.products]
      },
      ctaSource
    };

    let attachable = {
      product_id,
      qty
    };

    payload.changes.products.push(attachable);
    return new Promise((resolve, reject) => {
      dispatch('updateSubscription', payload).then(resolve).catch(reject);
    });
  },

  updateSubAttachmentQty({ dispatch, getters }, params) {
    let { sub_id, attachment_id, qty, ctaSource } = params;
    let sub = getters.getSubById(sub_id);
    let products = JSON.parse(JSON.stringify(sub.products));

    products.forEach(prod => {
      if (prod.product_id == attachment_id) {
        prod.qty = qty;
      }
    });

    let payload = {
      sub_id,
      changes: {
        products
      },
      ctaSource
    };

    return new Promise((resolve, reject) => {
      dispatch('updateSubscription', payload).then(resolve).catch(reject);
    });
  },

  removeSubAttachment({ dispatch, getters }, params) {
    let { sub_id, attachment_id, ctaSource } = params;
    let sub = getters.getSubById(sub_id);
    let products = sub.products.filter(prod => prod.product_id != attachment_id);

    let payload = {
      sub_id,
      changes: {
        products
      },
      ctaSource
    };

    return new Promise((resolve, reject) => {
      dispatch('updateSubscription', payload).then(resolve).catch(reject);
    });
  },

  cancelSubscription({ commit, dispatch, state }, params) {
    if (state.savingSub) {
      return;
    }

    commit('setSavingSub', true);
    return new Promise((resolve, reject) => {
      vueSubscriptionSvc.cancelSubscription(params)
        .then(() => {
          dispatch('loadCustomerSubs');
          dispatch('customer/refreshCustomerCdata', null, { root: true });
          resolve();
          commit('setSavingSub', false);
          dispatch('notifySuccess', 'Your subscription has been canceled', { root: true });
        })
        .catch(() => {
          reject();
          commit('setSavingSub', false);
          dispatch('notifyError', null, { root: true });
        });
    });
  },

  shipNow({ dispatch }, params) {
    shipRefillWithCart({
      subscriptionId: params.subId,
      includeSubsWithSameNext: params.includeSubsWithSameNext || false,
      nonPersistent: true
    }).then(() => {
      location.href = '/checkout';
    }).catch(error => {
      var errMsg = 'We were not able to ship this delivery now. Please try again or call Color Crew';

      if (error.response && error.response.data && error.response.data.code == 'PENDING_ORDERS') {
        errMsg = error.response.data.message;
      }

      dispatch('notifyError', errMsg, { root: true });
    });
  },

  getCancelReasons({ commit }, params) {
    let payload = {
      product_type: params.product_type,
      randomize: true
    };

    vueSubscriptionSvc.getCancelReasons(payload)
      .then(res => {
        var hasNNN = params.code.indexOf('NNN') < -1;

        var cancelReasons = res.data.reasons.map((reason) => {
          reason.mention_nnn = !hasNNN && reason.mention_nnn;
          return reason;
        });
        commit('setCancelReasons', cancelReasons);
      });
  },

  clearCancelData({ commit }) {
    commit('setCancelReason');
    commit('setCancelComment');
  },

  updateSubsToUpdate({ commit }, val) {
    commit('setSubsToUpdate', val);
  }
};

export const mutations = {
  setSubs(state, val) {
    state.subs = val;
  },

  setSubInEdit(state, subscription) {
    state.subInEdit = Object.assign({}, subscription);
  },

  setSubInEditFrequency(state, val) {
    state.subInEdit.frequency = val;
  },

  setSubInEditNext(state, val) {
    state.subInEdit.next = val;
  },

  setCancelReasons(state, val) {
    state.cancelReasons = val || [];
  },

  setCancelReason(state, val) {
    state.cancelData.reason = val || {};
  },

  setCancelComment(state, val) {
    state.cancelData.comment = val;
  },

  clearSubInEdit(state) {
    state.subInEdit = {};
  },

  setSavingSub(state, val) {
    state.savingSub = val;
  },

  setSubsToUpdate(state, val) {
    state.subsToUpdate = val || [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};